<template lang="pug">
    game-preview-settings(v-if="settings")
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_rootsAndDegrees') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
            span(slot="value") {{ $i18n.t('trainer')[parameters.mode] }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
            span(slot="value") {{ settings.amountOfExamples }}
        game-preview-setting(v-if="parameters.dictation")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_dictation') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        game-preview-setting(v-if="settings.timeForAnswer != '-1'")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
            span(slot="value")
                | {{ settings.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        template(v-if="settings.difficulties")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
                span(slot="value") {{ difficultyString }}
        template(v-if="parameters.fractions")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                span(slot="value") {{ parameters.fractionalPart }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}
            span(slot="value") {{ field('operations') }}
</template>

<script>
    import preview from '../../../utils/roots-and-degrees/preview';
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import { last } from 'lodash';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [preview],
        computed: {
            difficultyString() {
                let difficultyString = this.digitCapacityNames[last(this.settings.difficulties)];
                const combiningString = ' (' + this.$i18n.t('trainer.trainer_gameFormSettingValue_combination') + ')';
                difficultyString += this.settings.difficulties.length > 1 ? combiningString : '';
                return difficultyString;
            },
        },
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
    };
</script>
